import { createContext, useContext } from "react";
import { DutyStatusLogService } from "../../../model/DutyStatusLogs";


export class DutyStatusLogServiceContextType {
    constructor (public dutyStatusLogService: DutyStatusLogService) {}
}

export const DutyStatusLogServiceContext = createContext<DutyStatusLogServiceContextType | undefined>(undefined);

export const useDutyStatusLogServiceContext = (): DutyStatusLogServiceContextType => {
    const context = useContext(DutyStatusLogServiceContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the DutyStatusLogServiceContext");
    }
    return context;
};